module.exports = __webpack_public_path__ + "media/directory/edit_icon-dfcd633a.svg";